// extracted by mini-css-extract-plugin
module.exports = {"feedForm":"FeedForm_feedForm__KeuF1"};